import { render, staticRenderFns } from "./AlertFade.vue?vue&type=template&id=2883d999"
import script from "./AlertFade.vue?vue&type=script&lang=js"
export * from "./AlertFade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports